export enum FormaPagamentoDespesa {
  CAIXA = 'CAIXA',
  BANCO = 'BANCO',
}

export const DESCRICAO_FORMA_PAGAMENTO_DESPESA: { [key in FormaPagamentoDespesa]: string } = {
  [FormaPagamentoDespesa.CAIXA]: 'Caixa',
  [FormaPagamentoDespesa.BANCO]: 'Banco',
};
